import { render } from "./BookPetAppointmentPage.vue?vue&type=template&id=ef961fac"
import script from "./BookPetAppointmentPage.vue?vue&type=script&lang=js"
export * from "./BookPetAppointmentPage.vue?vue&type=script&lang=js"

import "./BookPetAppointmentPage.vue?vue&type=style&index=0&id=ef961fac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__